import React, { useEffect, useState } from 'react';
import { Col, Row, Container } from "react-bootstrap";
import { useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { postMailBookingList, postCustomerBookingApproveOrReject, postCustomerGmailAdd } from '../../Service';
import { InfinitySpin } from 'react-loader-spinner';
import logo from "../../images/logo.png";
import linkExpired from '../../images/link-expired.jpg';
import { JsonEncode } from '../Reusable/JsonModify';
import Swal from "sweetalert2";
import UseGoogleAuthCode from '../Reusable/UseGoogleAuthCode';
import { getTimeZoneName } from '../Reusable';

export default function AcceptBooking(){
    const params = useParams();
    const navigate = useNavigate();

    const { login, tokenResponse, failed } = UseGoogleAuthCode();

    const [pageLoader, setPageLoader] = useState(true);
    const [acceptBookingStatus, setAcceptBookingStatus] = useState(false);
    const [bookingData, setBookingData] = useState('');
    const [bookingId, setBookingId] = useState('');
    const [googleStatus, setGoogleStatus] = useState(false);
    const [timeZone, setTimeZone] = useState('');

    useEffect(() => {
        
        if ( !googleStatus ) {
            if ( tokenResponse !== null ) {
                setGoogleStatus(true);
                let payloadParams = {
                    'code' : tokenResponse,
                    'bookingId' : bookingId,
                    'timeZone' : getTimeZoneName(timeZone)
                }
                postCustomerGmailAdd(payloadParams).then(res => addGoogleCalendar(res));
            } else { 
                if ( failed.status ) {
                    Swal.fire({
                        position: 'center',
                        icon: '',
                        title: '',
                        showConfirmButton: false,
                        text: failed.message,
                        timer: 3000
                    });
                }
            }
        }

    }, [tokenResponse]);

    const addGoogleCalendar = ( res ) => {
        setGoogleStatus(false);
        
        if ( res.data.statusCode === 200 ) {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: res.data.statusMessage,
                showConfirmButton: false,
                timer: 3000
            });
        } else {
            Swal.fire({
                position: 'center',
                icon: '',
                title: '',
                showConfirmButton: false,
                text: 'Please provide the necessary permissions to add the booking to your calendar',
                timer: 3000
            }); 
        }
    }

    // get customer data from store
    const userData =  useSelector(store => store.user['customeruser']);

    useEffect(() => { 

        if ( userData ) {

            if ( userData.id == params.customerId ) {
                let bookingParams = {'customerId' : params.customerId, 'bookingId' : params.bookingId};
                postMailBookingList(bookingParams).then(res => bookingListResponse(res));
            } else {
                navigate('../../acceptrejectlogin/'+params.customerId+'/'+params.bookingId+'/'+1);
            }

        } else {
            navigate('../../acceptrejectlogin/'+params.customerId+'/'+params.bookingId+'/'+1);
        }

    }, []);

    const bookingListResponse = async ( res ) => {

        if ( res.data.bookingList != null && (res.data.bookingList.bookingType == 'CL' || res.data.bookingList.bookingType == 'CLEB') && res.data.bookingList.isCustomerRespondent == false && res.data.bookingList.status == 'Booked' ) {
            setBookingData(res.data.bookingList);
            let bookingDetails = res.data.bookingList;
            setTimeZone(bookingDetails.timeZone);

            let acceptParams = {'bookingId' : bookingDetails.bookingId, 'customerAccepts' : true, 'customerRejects' : false, 'wrongCustomer' : false, 'serviceId' : bookingDetails.serviceid, 'serviceName' : bookingDetails.serviceName, 'payment' : bookingDetails.payment, 'serviceCost' : bookingDetails.serviceCost, 'platformFees' : bookingDetails.platformFee, 'tip' : bookingDetails.tip, 'clientId' : bookingDetails.clientId, 'customerId' : bookingDetails.customerId};

            let jsonData = await JsonEncode(acceptParams).then(result => {
                return result
            }).catch(error => {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Oops...',
                    showConfirmButton: false,
                    text: error,
                    timer: 3000
                }); 
            });
            
            if ( jsonData ) {
                let loginPayload = {data : jsonData};
                postCustomerBookingApproveOrReject(loginPayload).then(res => acceptHandleResponse(res));
            } else {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Oops...',
                    showConfirmButton: false,
                    text: 'Something went wrong, Please try after sometimes',
                    timer: 3000
                }); 
            }
            
        } else {
            setPageLoader(false);
        }

    }

    const acceptHandleResponse = ( res ) => {

        if ( res.data.statusCode === 200 ) {
            setAcceptBookingStatus(true);
            setPageLoader(false);
            setBookingId(res.data.bookingId)

            if ( res.data.googleCalendar === 'InActive' ) {
                Swal.fire({
                    html: `
                        <div style="text-align: center;">
                            <div style="font-size: 60px; color: #28a745;">✓</div>
                            <h2 style="margin-top: 10px;">Slot booked successfully</h2>
                            <p><strong><span style="color: #28a745;">Add to Google Calendar</span></strong>?</p>
                        </div>
                    `,
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Add',
                    cancelButtonText: 'x',
                    allowOutsideClick: false,
                    customClass: {
                        popup: 'swal2-popup-custom',
                        confirmButton: 'swal2-confirm-custom',
                        cancelButton: 'swal2-cancel-custom'
                    }
                }).then((result) => {
                    if (result.isConfirmed) {
                        login();
                    }
                }) 
            }

        } else {
            setPageLoader(false);
        }

    }

    const handleHome = () => {
        navigate('/');
    }

    return(
        <>
            {
                pageLoader === true ?
                    <div className='acceptRejectLoader'>
                        <InfinitySpin height="80" width="200" radius="9" color="#D49D29" ariaLabel="loading" wrapperStyle wrapperClass />
                    </div>
                :
                    <section className="emailTip">
                        <Container>
                            <Row>
                                <Col>
                                    <div className="text-center">
                                        <img src={logo} />
                                    </div>
                                </Col>
                            </Row>
                            {
                                bookingData != '' && acceptBookingStatus === true ?
                                    <div>
                                        <p className='tipThanks'>Thank you. Your booking has been accepted successfully.</p>
                                        <p className='tipThanks'>We are really excited to serve you again. <span onClick={handleHome} style={{cursor : 'pointer', color : '#8aaee2'}}>Click here</span> to visit Unext Homepage. </p>
                                    </div>
                                :
                                    <div style={{textAlign:'center', marginTop : '16px'}}>
                                        <img src={linkExpired} className='img-responsive' />
                                    </div>
                            }
                        </Container>
                    </section>
            }
        </>
    )
}